import React, { useState } from "react";
import { Box, Toolbar, styled } from "@mui/material";
import { LeftNavBar, NavigationSync, TopNavBar } from "../components";
import { useNavigation } from "@hooks";

const Frame = styled(Box)(() => ({
  display: "flex",
  position: "relative",
  width: "100%",
  height: "100vh",
  minHeight: "100vh",
  backgroundColor: "#F3F1FB",
}));

const Wrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  position: "relative",
}));

const Navigation = ({ children }) => {
  const { navigate, showNav, isMobileNav } = useNavigation();

  // Indicates whether the left panel is open when in mobile navigation
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
    // Fallback to reset isClosing even if onTransitionEnd doesn't fire
    setTimeout(() => {
      setIsClosing(false);
    }, 300); // 300ms is roughly the default MUI drawer transition time
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleNavigate = (destination) => {
    navigate(destination);
    handleDrawerClose();
  };

  return (
    <>
      {/* {showNav && isMobileNav && <TopNavBar toggle={handleDrawerToggle} navigate={handleNavigate} />} */}
      <Frame>
        <NavigationSync />
        {/* {showNav && <LeftNavBar {...{ mobileOpen, handleDrawerClose, handleDrawerTransitionEnd, handleNavigate }} />} */}
        <Wrapper>
          {/* Blank ToolBar precedes page content to avoid overlap */}
          {/* {showNav && isMobileNav && <Toolbar />} */}
          {children}
        </Wrapper>
      </Frame>
    </>
  );
};

export default Navigation;
